import { render, staticRenderFns } from "./Vimeo.vue?vue&type=template&id=2f74ac06&"
import script from "./Vimeo.vue?vue&type=script&lang=ts&"
export * from "./Vimeo.vue?vue&type=script&lang=ts&"
import style0 from "./Vimeo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports